import { motion } from "framer-motion";

const CERTS = ["Zscaler certified", "Delinea certified", "CrowdStrike certified", "Rubrik certified", "SentinelOne certified"];

export default function CertifiedExpertise() {
  return (
    <section
      data-testid="certified-expertise"
      className="theme-editorial relative py-20 md:py-24 border-t border-[rgba(17,17,17,0.10)]"
      aria-label="Certified expertise"
    >
      <div className="mx-auto max-w-[1280px] px-6 md:px-10 grid md:grid-cols-12 gap-6 md:gap-10 items-center">
        <div className="md:col-span-5">
          <div className="font-mono text-[10px] tracking-[0.32em] text-[#8A8A8A] mb-3">
            [ CERTIFIED · EXPERTISE ]
          </div>
          <h2 className="font-editorial-display text-[32px] md:text-[44px] leading-[1.02] tracking-[-0.02em] text-[#111]">
            Backed by <span className="font-editorial-italic text-[#5B2A86]">industry-recognized</span> credentials.
          </h2>
        </div>
        <div className="md:col-span-7 space-y-2">
          {CERTS.map((c, i) => (
            <motion.div
              key={c}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`cert-${i}`}
              className="flex items-center gap-5 py-3 border-b border-[rgba(17,17,17,0.08)]"
            >
              <span className="font-mono text-[10px] tracking-[0.28em] text-[#5B2A86] w-12">/ 0{i + 1}</span>
              <span className="font-editorial-display text-[22px] md:text-[26px] leading-tight text-[#111]">
                {c}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
